import { createContext } from 'react';

/**
 * React Context for translation loader
 *
 * @type {React.Context}
 * @access private
 */

var LoaderContext = /*#__PURE__*/createContext();
/**
 * React Context for translation methods
 *
 * @type {React.Context}
 * @access private
 */

var TranslateContext = /*#__PURE__*/createContext();

export { LoaderContext, TranslateContext };
